import React from 'react'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled from 'styled-components'
import media from 'css-in-js-media'

import { Variables } from '../styles/Variables'
import Button from './Button'
import { StyledButton } from './ButtonStyled'
import { BodyCopy, H2 } from './Typography'
import AnimatedSection from './AnimatedSection'
import { FormattedMessage } from 'react-intl'

const StyledRow = styled(Row)`
    background-color: ${Variables.color.pazola};
    padding: 80px 20px;

    ${media('<desktop')} {
        padding: 60px 20px;
    }

    ${BodyCopy} {
        color: ${Variables.color.white};
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0.1em;
        text-transform: uppercase;

        ${media('<desktop')} {
            font-size: 12px;
            line-height: 130%;
        }
    }
    ${H2} {
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 300;
        font-size: 32px;
        line-height: 37px;
        color: ${Variables.color.white};
        padding: 0;

        ${media('<desktop')} {
            font-size: 24px;
            line-height: 30px;
        }
    }
    ${StyledButton} {
        min-width: 164px;        
        color: ${Variables.color.white};
        &:hover {
            background-color: ${Variables.color.pazolaGold};
            color: ${Variables.color.white};
            &::before {
                border-color: ${Variables.color.white};
            }
        }
    }
`

interface Props {
    data?: any
}

const PreFooter = ({ data }: Props) => {
    const { subfooter } = data

    return (
        <AnimatedSection>
            <StyledRow middle="md" center="md">
                <Col xs={12} md={9}>
                    {subfooter?.headingTitle && <BodyCopy>{subfooter?.headingTitle.headingTitle}</BodyCopy>}
                    {subfooter && (
                        <H2
                            dangerouslySetInnerHTML={{
                                __html: subfooter?.copy?.childMarkdownRemark?.html,
                            }}
                        />
                    )}
                    <Button buttonLink={{ internalLink: { slug: 'contact' } }} secondary>
                        <FormattedMessage id={'contact us'} />
                    </Button>
                </Col>
            </StyledRow>
        </AnimatedSection>
    )
}

export default PreFooter
